// extracted by mini-css-extract-plugin
export default {"container":"priceBadgeContainer-module__container__EPCIR","tooltip":"priceBadgeContainer-module__tooltip__dU1-4"};